import generateTypes from '../utils/generateTypes';

export const GET_EMAILS = generateTypes('GET_EMAILS');
export const RESET_EMAILS = generateTypes('RESET_EMAILS');
